
export class ZipCodeLocator extends HTMLElement
{
    constructor ()
    {
        super();
    }

    init(map)
    {
        this.map = map;
        this.#initZipCodeLocator();
        this.#initEventHandlers();
    }

    #initEventHandlers()
    {
        const goBtn = this.querySelector('button');
        this.onZipCodeLocatorClick = this.onZipCodeLocatorClick.bind(this);
        goBtn.addEventListener('click', this.onZipCodeLocatorClick);

        const zipCodeInputElem = this.querySelector('input#zip-locator-input');
        this.onZipCodeInputKeyPressEvent = this.onZipCodeInputKeyPressEvent.bind(this);
        zipCodeInputElem.addEventListener('keypress', this.onZipCodeInputKeyPressEvent);

    }

    #initZipCodeLocator()
    {
        this.#createZipCodeLocator();
        this.map.controls[google.maps.ControlPosition.BOTTOM_LEFT].push(this);

    }

    #createZipCodeLocator()
    {
        this.setAttribute('id', 'geomap-zipcode-locator');

        const locatorMarkup = `
<div class="locator-container">
    <h4 class="locator-header">Map Locator</h4>
    <div class="zip-locator-body">
        <label>Specify a zip code below to center the map on your desired zip code</label>
        <input id="zip-locator-input"/>
        <button class="zip-locator-btn">Go!</button>
    </div>
</div>
`;
        const parser = new DOMParser();
        const htmlElem = parser.parseFromString(locatorMarkup, 'text/html').documentElement;
        const locatorElem = htmlElem.querySelector('.locator-container');
        this.appendChild(locatorElem );
    }

    async onZipCodeLocatorClick(event)
    {
        let inputElem = event.target;
        if (inputElem.tagName != 'INPUT') {
            inputElem = event.target.previousElementSibling;
        }
        const zip = inputElem.value;

        const isValidZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
        if (!isValidZip) {
            inputElem.setCustomValidity('Please enter a valid zip code (ddddd or ddddd-dddd)');
            inputElem.reportValidity();
            return;
        }

        inputElem.setCustomValidity('');
        const _this = this;

        const {Geocoder} = await google.maps.importLibrary("geocoding")

        var lat = '';
        var lng = '';
        var address = zip;
        const geoCoder = new Geocoder();
        geoCoder.geocode( { 'address': address}, (results, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
                inputElem.value = '';
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();
                _this.map.setCenter(new google.maps.LatLng(lat, lng));
                _this.map.setZoom(11);
                const evt = new CustomEvent('geomap-zipcode-locator-change-event', {
                    detail: {
                        originalEvent: event
                    }
                });
                document.dispatchEvent(evt);
            } else {
                inputElem.setCustomValidity(status);
                inputElem.reportValidity();
            }
        });
    }

    onZipCodeInputKeyPressEvent(event)
    {
        event.target.setCustomValidity('');
        if (event.key === 'Enter') {
            this.onZipCodeLocatorClick(event);
        }
    }

}

customElements.define('geomap-zipcode-locator', ZipCodeLocator);